import { __extends } from "tslib";
import { TaskBaseWebGL } from './TaskBaseWebgGL';
var EMPTY_TRANSFORM = new Float32Array([1, 1, 1, 1, 0, 0, 0, 0]);
var EMPTY_MATRIX = new Float32Array([
    1, 0, 0, 0,
    0, 1, 0, 0,
    0, 0, 1, 0,
    0, 0, 0, 1,
    // offsets
    0, 0, 0, 0
]);
var TRANSFORM_PART = "\nuniform vec4 uTransformData[2];\n\nvec4 transform(vec4 color) {\n\tif (color.a > 0.0) {\n\t\tcolor.rgb /= color.a;\n\t}\n\n\tcolor *= clamp(uTransformData[0], 0.0, 1.0);\t\n\tcolor += uTransformData[1];\n\n\tcolor.rgb *= clamp(color.a, 0., 1.);\n\treturn color;\n}\n";
var MATRIX_PART = "\nuniform vec4 uTransformData[5];\n\nvec4 transform(vec4 color) {\n\tif (color.a > 0.0) {\n\t\tcolor.rgb /= color.a;\n\t}\n\n\tvec4 ret = uTransformData[4];\n\tret.r += dot(color, uTransformData[0]);\n\tret.g += dot(color, uTransformData[1]);\n\tret.b += dot(color, uTransformData[2]);\n\tret.a += dot(color, uTransformData[3]);\n\n\tret = clamp(ret, 0., 1.);\n\tret.rgb *= ret.a;\n\t\n\treturn ret;\n}\n";
var FRAG = function (mode) { return "\nprecision highp float;\nuniform sampler2D fs0;\n\nvarying vec2 vUv;\n\n" + (mode === 'transform'
    ? TRANSFORM_PART
    : mode === 'matrix'
        ? MATRIX_PART : '') + "\nvoid main() {\n\tvec4 color = texture2D(fs0, vUv);\n\n    gl_FragColor = " + (mode ? 'transform(color)' : 'color') + ";\n}"; };
var ColorMatrixTask = /** @class */ (function (_super) {
    __extends(ColorMatrixTask, _super);
    function ColorMatrixTask() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activateInternaly = false;
        _this._dataChanged = false;
        _this._mode = '';
        _this._focusId = -1;
        return _this;
    }
    Object.defineProperty(ColorMatrixTask.prototype, "transform", {
        get: function () {
            return this._transform;
        },
        set: function (value) {
            if (this._transform === value && !value) {
                return;
            }
            this._transform = value;
            this._dataChanged = true;
            if (!this._fragData || this._fragData.length !== 8) {
                this._fragData = new Float32Array(8);
            }
            if (value) {
                this._fragData.set(value._rawData);
                for (var i = 4; i < 8; i++) {
                    this._fragData[i] /= 0xff;
                }
                // disable positive ALPHA offset, because can't allowed in PMA mode
                if (this._fragData[7] > 0)
                    this._fragData[7] = 0;
            }
            else {
                this._fragData.set(EMPTY_TRANSFORM);
            }
            var mode = value ? 'transform' : '';
            if (this._mode !== mode) {
                this._mode = mode;
                this.invalidateProgram();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixTask.prototype, "matrix", {
        get: function () {
            return this._matrix;
        },
        set: function (value) {
            this._matrix = value;
            if (!this._fragData || this._fragData.length !== 20) {
                this._fragData = new Float32Array(20);
            }
            if (value) {
                for (var i = 0; i < 4; i++) {
                    for (var j = 0; j < 4; j++) {
                        // we should get 4 of 5, because matrix store data as
                        // mulR, mulG, mulB, mulA, offsetR
                        this._fragData[j + i * 4] = value[j + i * 5];
                    }
                    // pack offsets to latest vector
                    this._fragData[16 + i] = value[4 + i * 5] / 0xff;
                }
                //for (let i = 16; i < 20; i++)
                //	this._fragData[i] = value[i * 4 + 5] / 0xff;
            }
            else {
                this._fragData.set(EMPTY_MATRIX);
            }
            var mode = value ? 'matrix' : '';
            if (this._mode !== mode) {
                this._mode = mode;
                this.invalidateProgram();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixTask.prototype, "name", {
        get: function () {
            return 'CopyPixel:' + this._mode;
        },
        enumerable: false,
        configurable: true
    });
    ColorMatrixTask.prototype.getFragmentCode = function () {
        return FRAG(this._mode);
    };
    ColorMatrixTask.prototype.activate = function (_stage, _projection, _depthTexture) {
        _super.prototype.computeVertexData.call(this);
        this._source.getAbstraction(_stage).activate(0);
        var prog = this._program3D;
        prog.uploadUniform('uTexMatrix', this._vertexConstantData);
        // upload only when a transform a REAL changed or after shader rebound
        if (this._mode && (this._dataChanged || prog.focusId !== this._focusId)) {
            prog.uploadUniform('uTransformData', this._fragData);
        }
        this._focusId = prog.focusId;
        this._dataChanged = false;
    };
    return ColorMatrixTask;
}(TaskBaseWebGL));
export { ColorMatrixTask };
